import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const PdfFileIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path
                d="M3.7002 16.6C3.7002 17.042 3.87579 17.4659 4.18835 17.7785C4.50091 18.091 4.92483 18.2666 5.36686 18.2666H15.3669C15.8089 18.2666 16.2328 18.091 16.5454 17.7785C16.8579 17.4659 17.0335 17.042 17.0335 16.6V7.43331L11.2002 1.59998H5.36686C4.92483 1.59998 4.50091 1.77557 4.18835 2.08813C3.87579 2.40069 3.7002 2.82461 3.7002 3.26664V7.93331"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.2002 1.59998V7.43331H17.0335"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.66602 14.8V10.1H3.68395C4.03092 10.1 4.33452 10.1688 4.59475 10.3065C4.85498 10.4442 5.05739 10.6378 5.20196 10.8871C5.34653 11.1365 5.41882 11.428 5.41882 11.7615C5.41882 12.0981 5.34425 12.3895 5.19511 12.6359C5.04749 12.8822 4.83977 13.0719 4.57193 13.205C4.30561 13.3381 3.9944 13.4047 3.63829 13.4047H2.43301V12.4133H3.38263C3.53176 12.4133 3.65883 12.3872 3.76384 12.3352C3.87037 12.2817 3.95178 12.2059 4.00809 12.108C4.06592 12.0101 4.09484 11.8946 4.09484 11.7615C4.09484 11.6269 4.06592 11.5121 4.00809 11.4173C3.95178 11.3209 3.87037 11.2474 3.76384 11.1969C3.65883 11.1449 3.53176 11.1189 3.38263 11.1189H2.93521V14.8H1.66602Z"
                fill="currentColor"
                stroke="none"
            />
            <path
                d="M7.68328 14.8H5.88449V10.1H7.66502C8.14591 10.1 8.56137 10.1941 8.91139 10.3823C9.26293 10.5689 9.53381 10.8382 9.72404 11.1901C9.91579 11.5404 10.0117 11.9604 10.0117 12.45C10.0117 12.9396 9.91655 13.3603 9.72632 13.7122C9.53609 14.0625 9.26673 14.3318 8.91824 14.52C8.56974 14.7066 8.15809 14.8 7.68328 14.8ZM7.15369 13.7168H7.63763C7.86894 13.7168 8.06602 13.6793 8.22885 13.6043C8.39321 13.5294 8.518 13.4001 8.60322 13.2165C8.68996 13.0329 8.73333 12.7774 8.73333 12.45C8.73333 12.1226 8.6892 11.8671 8.60094 11.6835C8.51419 11.4999 8.38636 11.3706 8.21744 11.2956C8.05004 11.2207 7.84459 11.1832 7.6011 11.1832H7.15369V13.7168Z"
                fill="currentColor"
                stroke="none"
            />
            <path
                d="M10.5989 14.8V10.1H13.886V11.1281H11.8681V11.9359H13.6851V12.964H11.8681V14.8H10.5989Z"
                fill="currentColor"
                stroke="none"
            />
        </SvgIcon>
    );
};
